export const calcDirectionWithBearing = (directionDeg: number, bearingDeg: number): number => {
  return directionDeg > bearingDeg ? directionDeg - bearingDeg : 360 + directionDeg - bearingDeg
}
